// extracted by mini-css-extract-plugin
export default {"logo":"logo--oBm1T","logo-white":"logo-white--6+Hvg","logoWhite":"logo-white--6+Hvg","logo-dark":"logo-dark--24FUL","logoDark":"logo-dark--24FUL"};